import { AppModule, ResourceAppModule } from "@/shared/app";
import { plmApp } from "../app";
import {
  recepturaResource,
  Receptura,
} from "@megarax/client/src/resources/plm";

export const recepturaModule: ResourceAppModule = {
  formComponent: () => import("./ItemForm.vue"),
  sheetComponent: () => import("./ItemSheet.vue"),
  listComponent: () => import("./ItemList.vue"),
  title: "Receptury",
  route: "receptura",
  iconClass: "fas fa-vial fa-fw",
  app: plmApp,
  resource: recepturaResource,
  itemConstructor: Receptura,
};
